// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__18cwy","col":"CardReaderDesc_col__2AdGx","label":"CardReaderDesc_label__3yb4S"};